/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { GetIrrConfigResponse } from '../model/getIrrConfigResponse';
// @ts-ignore
import { IrrReConfigureTenantSpec } from '../model/irrReConfigureTenantSpec';
// @ts-ignore
import { PreUnlinkPhaseEnum } from '../model/preUnlinkPhaseEnum';
// @ts-ignore
import { PreUnlinkVmcOrgResponse } from '../model/preUnlinkVmcOrgResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class OrchestratorVcdrService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Checks if a VMC org can be unlinked or not
     * Checks if a VMC org can be unlinked or not and returns SDDC and uncommitted plans details
     * @param orgId Organization identifier
     * @param serviceType Service Type
     * @param irrFqdn FQDN of IRR
     * @param preUnlinkPhase PreUnlink phase
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public preUnlinkVMCVcdr(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn: string, preUnlinkPhase: PreUnlinkPhaseEnum, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<PreUnlinkVmcOrgResponse>;
    public preUnlinkVMCVcdr(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn: string, preUnlinkPhase: PreUnlinkPhaseEnum, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PreUnlinkVmcOrgResponse>>;
    public preUnlinkVMCVcdr(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn: string, preUnlinkPhase: PreUnlinkPhaseEnum, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PreUnlinkVmcOrgResponse>>;
    public preUnlinkVMCVcdr(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn: string, preUnlinkPhase: PreUnlinkPhaseEnum, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling preUnlinkVMCVcdr.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling preUnlinkVMCVcdr.');
        }
        if (irrFqdn === null || irrFqdn === undefined) {
            throw new Error('Required parameter irrFqdn was null or undefined when calling preUnlinkVMCVcdr.');
        }
        if (preUnlinkPhase === null || preUnlinkPhase === undefined) {
            throw new Error('Required parameter preUnlinkPhase was null or undefined when calling preUnlinkVMCVcdr.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>irrFqdn, 'irr-fqdn');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>preUnlinkPhase, 'pre-unlink-phase');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/orchestrator/vmc/pre-unlink`;
        return this.httpClient.request<PreUnlinkVmcOrgResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reconfigure IRR Config tenant API.
     * Unlink VMC org, configure IRR mode and settings.
     * @param orgId Organization identifier
     * @param irrReConfigureTenantSpec IRR Tenant Reconfigure Spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reconfigureOrchestratorVcdr(orgId: string, irrReConfigureTenantSpec: IrrReConfigureTenantSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<GetIrrConfigResponse>;
    public reconfigureOrchestratorVcdr(orgId: string, irrReConfigureTenantSpec: IrrReConfigureTenantSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetIrrConfigResponse>>;
    public reconfigureOrchestratorVcdr(orgId: string, irrReConfigureTenantSpec: IrrReConfigureTenantSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetIrrConfigResponse>>;
    public reconfigureOrchestratorVcdr(orgId: string, irrReConfigureTenantSpec: IrrReConfigureTenantSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling reconfigureOrchestratorVcdr.');
        }
        if (irrReConfigureTenantSpec === null || irrReConfigureTenantSpec === undefined) {
            throw new Error('Required parameter irrReConfigureTenantSpec was null or undefined when calling reconfigureOrchestratorVcdr.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/orchestrator/reconfigure`;
        return this.httpClient.request<GetIrrConfigResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: irrReConfigureTenantSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
